import { Currency } from '@models/ropolo';

const mapCurrencyLabel = (inputCurrency?: Currency, compact?: boolean) => {
  switch (inputCurrency) {
    case Currency.RIAL:
      return 'ریال';

    default:
      if (compact) {
        return 'ت';
      }
      return 'تومان';
  }
};

const getCurrencyConversionRate = (inputCurrency?: Currency) => {
  switch (inputCurrency) {
    case Currency.RIAL:
      return 10;
    default:
      return 1;
  }
};

const formatPrice = ({
  price = 0,
  currency = Currency.TOMAN,
  showZero = false,
}: {
  price?: number;
  currency?: Currency;
  showZero: boolean;
}) => {
  let showPrice = price;

  if (currency === Currency.RIAL) {
    showPrice = price * 10;
  }

  const isFree = showPrice === 0;

  const zero = showZero ? '0' : 'رایگان';
  const formattedPrice = isFree ? zero : showPrice.toLocaleString();

  return formattedPrice;
};

const currencyUtil = { mapCurrencyLabel, formatPrice, getCurrencyConversionRate };

export default currencyUtil;
